import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
import Brands from '../Brands/Brands';
import * as Styled from '../../Footer.styles';
var imgPath = '//media.4rgos.it/i/Argos/checkout';
var checkoutImages = [{
  type: 'argospay',
  path: "".concat(imgPath, "_argospay")
}, {
  type: 'klarna',
  path: "".concat(imgPath, "_klarna")
}, {
  type: 'visa',
  path: "".concat(imgPath, "_visa")
}, {
  type: 'mastercard',
  path: "".concat(imgPath, "_mastercard")
}, {
  type: 'amex',
  path: "".concat(imgPath, "_amex")
}, {
  type: 'paypal',
  path: "".concat(imgPath, "_paypal")
}, {
  type: 'ssl',
  path: "".concat(imgPath, "_ssl")
}];

var Checkout = function Checkout(_ref) {
  var _ref$nativeLazy = _ref.nativeLazy,
      nativeLazy = _ref$nativeLazy === void 0 ? false : _ref$nativeLazy,
      _ref$checkoutLogosTyp = _ref.checkoutLogosType,
      checkoutLogosType = _ref$checkoutLogosTyp === void 0 ? 'payment' : _ref$checkoutLogosTyp,
      brands = _ref.brands,
      _ref$argosPayHidden = _ref.argosPayHidden,
      argosPayHidden = _ref$argosPayHidden === void 0 ? true : _ref$argosPayHidden;
  return /*#__PURE__*/React.createElement(Styled.CheckoutFooter, {
    className: "container container--row"
  }, /*#__PURE__*/React.createElement(Styled.CheckoutFooterRow, {
    className: "md-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md-12",
    "data-test": "footer-checkout"
  }, checkoutLogosType === 'payment' && /*#__PURE__*/React.createElement(Styled.CheckoutLogos, null, checkoutImages.filter(function (image) {
    return !(argosPayHidden && image.type === 'argospay');
  }).map(function (image) {
    return /*#__PURE__*/React.createElement(Image, {
      key: image.type,
      src: image.path,
      alt: "".concat(image.type, " logo"),
      height: 40,
      quality: 80,
      "data-test": "footer-checkout-logo",
      responsive: true,
      lazy: true,
      nativeLazy: nativeLazy,
      lazyWrapElement: "span"
    });
  })), checkoutLogosType === 'brand' && /*#__PURE__*/React.createElement(Brands, {
    nativeLazy: nativeLazy,
    brands: brands
  }))));
};

Checkout.propTypes = {
  nativeLazy: PropTypes.bool,
  checkoutLogosType: PropTypes.oneOf(['payment', 'brand']),
  argosPayHidden: PropTypes.bool,
  brands: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    dataTest: PropTypes.string.isRequired,
    linkAttributes: PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired
    })
  })).isRequired).isRequired
};
export default Checkout;